import { render } from "./UploadWithPreview.vue?vue&type=template&id=604b7b86&scoped=true"
import script from "./UploadWithPreview.vue?vue&type=script&lang=js"
export * from "./UploadWithPreview.vue?vue&type=script&lang=js"

import "./UploadWithPreview.vue?vue&type=style&index=0&id=604b7b86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604b7b86"]])

export default __exports__